import React from 'react';
import { Grid, Card, Typography, Box } from '@mui/material';
import { useDevice } from 'components/DeviceContext.js';
import { Link } from 'react-router-dom';
import organizersData from './organizersData';

const OrganizerCard = ({ name, title, imgOrganizadores, bgColor, bgColorNome, bgColorCargo, isMobile, isLaptop, isDesktop }) => (
	<Card
		style={{
			borderRadius: '30px 0 30px 0',
			height: isMobile ? '400px' : isLaptop ? '400px' : isDesktop ?  '360px' : '380px' , // Altura menor em mobile
			width: isMobile ? '320px' : isLaptop ? '200px' : isDesktop ?  '200px' : '280px', // Largura menor em mobile
			display: 'flex',
			flexDirection: 'column',
			justifyContent: 'space-between',
			transition: 'transform 0.3s ease-in-out',
			backgroundColor: bgColor,
			marginBottom: isMobile ? '2em' : '',
		}}
		onMouseOver={(e) => e.currentTarget.style.transform = 'scale(1.1)'}
		onMouseOut={(e) => e.currentTarget.style.transform = 'scale(1)'}
	>
		<Grid style={{ textAlign: 'center' }}>
			<Box display="flex" justifyContent="center" mb={1} style={{ padding: 0 }}>
				<img
					alt={name}
					src={imgOrganizadores}
					style={{ width: isMobile ? '100%' : isLaptop ? '400px' : '400px', height: isMobile ? '290px' : isLaptop ? '250px' : '266px', objectFit: 'cover', padding: 0, borderRadius: '0 0 30px 0' }}
				/>
			</Box>
			<Typography variant="h5" gutterBottom style={{ color: bgColorNome, fontWeight: 'bold' }}>
				{name}
			</Typography>
			<Typography variant="h5" style={{ color: bgColorCargo, fontWeight: 'bold', fontSize: isMobile ? '1.2em' : '1.4em' }}>
				{title}
			</Typography>
		</Grid>
	</Card>
);

const PalavraOrganizadores = () => {
	const { isMobile, isLaptop, isDesktop } = useDevice();
	const organizers = organizersData;

	return (
		<Grid container style={{ display: 'flex', justifyContent: 'center'  }}>
			<Grid direction="column" alignItems="center" style={{ padding: '20px', width: isMobile ? '100%' :  isLaptop ? '90%' : '85%',  borderRadius: '5em 5em 0 0', boxShadow: '0px 0.1px 200px rgba(255, 255, 255, 10.55)', backgroundColor: 'rgba(255, 255, 255, 0.8)' }}>
				<Typography variant="h2" align="center" gutterBottom style={{ color: '#0d4d9f', fontSize: isMobile ? '1.6em' : '3em', paddingTop: '1em', fontWeight: 'bold'  }}>
					Palavra dos Organizadores
				</Typography>
				<Typography
					variant="h5"
					align="center"
					gutterBottom
					style={{
						color: 'var(--cinza-padrao-letra)',
						fontSize: isMobile ? '1em' : '1.8em',
						letterSpacing: '2px',
						margin: isDesktop ? '1.4em' : '2em 0',
						fontWeight: 'bold',
					}}
				>
					Unidos para valorizar e fortalecer o potencial das Cidades Históricas,
					<br /> Turísticas e os Sítios do Patrimônio Mundial
				</Typography>
				<Grid container justifyContent="space-around">
    {organizers.map((organizer, index) => (
			<Link to={`/organizador/${organizer.name}`} style={{ textDecoration: 'none'}} >
        <Grid item xs={12} sm={6} md={4} lg={2} xl={2} key={index} style={{width: '100%'}}>
            <OrganizerCard {...organizer} isMobile={isMobile} isLaptop={isLaptop}/>
        </Grid>
			</Link>
    ))}
</Grid>

			</Grid>
		</Grid>
	);
};

export default PalavraOrganizadores;
